import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { ease } from '../../styles/tokens';

const Wrapper = styled.div`
  opacity: ${(p) => (p.$shown ? 1 : 0)};
  transform: translateY(${(p) => (p.$shown ? '0' : '18px')});
  transition: opacity 0.7s ${ease}, transform 0.7s ${ease};
  transition-delay: ${(p) => p.$delay}ms;

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    transform: none;
  }
`;

// Fades content up as it scrolls into view. Reveals once, then stops observing.
function Reveal({ children, delay = 0, as }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || typeof IntersectionObserver === 'undefined') {
      setShown(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShown(true);
          observer.disconnect();
        }
      },
      { rootMargin: '0px 0px -12% 0px' }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Wrapper ref={ref} as={as} $shown={shown} $delay={delay}>
      {children}
    </Wrapper>
  );
}

export default Reveal;
